export const noGroupsText = 'No groups to display';
